const EYE_ICONS_HTML = `
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-eye-icon lucide-eye">
      <path d="M2.062 12.348a1 1 0 0 1 0-.696 10.75 10.75 0 0 1 19.876 0 1 1 0 0 1 0 .696 10.75 10.75 0 0 1-19.876 0"/>
      <circle cx="12" cy="12" r="3"/>
    </svg>
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-eye-off-icon lucide-eye-off hidden">
      <path d="M10.733 5.076a10.744 10.744 0 0 1 11.205 6.575 1 1 0 0 1 0 .696 10.747 10.747 0 0 1-1.444 2.49"/>
      <path d="M14.084 14.158a3 3 0 0 1-4.242-4.242"/>
      <path d="M17.479 17.499a10.75 10.75 0 0 1-15.417-5.151 1 1 0 0 1 0-.696 10.75 10.75 0 0 1 4.446-5.143"/>
      <path d="m2 2 20 20"/>
    </svg>
  `;

export function initPasswordToggle() {
  const passwordInput = document.querySelector('input[type="password"][name="pass"]');
  if (!passwordInput) return;

  const wrapper = document.createElement('div');
  wrapper.className = 'relative';

  passwordInput.parentNode.insertBefore(wrapper, passwordInput);
  wrapper.appendChild(passwordInput);

  passwordInput.className = passwordInput.className.replace('p-2', 'p-2 pr-10');

  const toggleButton = document.createElement('button');
  toggleButton.type = 'button';
  toggleButton.className =
    'absolute right-0 h-full transform top-1/2 -translate-y-1/2 pr-3 focus:outline-none text-gray-550';
  toggleButton.setAttribute('aria-label', 'Passwort anzeigen');
  toggleButton.innerHTML = EYE_ICONS_HTML;

  const eyeIcon = toggleButton.querySelector('.lucide-eye');
  const eyeOffIcon = toggleButton.querySelector('.lucide-eye-off');

  wrapper.appendChild(toggleButton);

  toggleButton.addEventListener('click', () => {
    if (passwordInput.type === 'password') {
      passwordInput.type = 'text';
      toggleButton.setAttribute('aria-label', 'Passwort verbergen');
      eyeIcon.classList.add('hidden');
      eyeOffIcon.classList.remove('hidden');
    } else {
      passwordInput.type = 'password';
      toggleButton.setAttribute('aria-label', 'Passwort anzeigen');
      eyeIcon.classList.remove('hidden');
      eyeOffIcon.classList.add('hidden');
    }
  });
}
